













import Vue from 'vue';
import * as icons from '@/icons';

import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon
  },

  data() {
    return {
      icons: icons.default.icons
    };
  },

  methods: {
    selectIcon(iconData: icons.IconData) {
      this.$emit('icon-selected', iconData);
    }
  }
});
